import { vars } from '@planner/tokens/css';
import { style } from '@vanilla-extract/css';

export const root = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: vars.space['3'],
  padding: `${vars.space['10']} ${vars.space['6']}`,
  textAlign: 'center',
  color: vars.color.text.default,
});

export const icon = style({
  display: 'grid',
  placeItems: 'center',
  width: vars.space['12'],
  height: vars.space['12'],
  marginBottom: vars.space['1'],
  borderRadius: vars.radius.full,
  backgroundColor: vars.color.bg.muted,
  color: vars.color.text.muted,
});

export const title = style({
  fontSize: vars.font.size.lg,
  fontWeight: vars.font.weight.semibold,
  lineHeight: vars.font.lineHeight.snug,
});

export const description = style({
  maxWidth: vars.size.dialogSm,
  fontSize: vars.font.size.md,
  color: vars.color.text.muted,
});

export const action = style({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: vars.space['2'],
  marginTop: vars.space['2'],
});
